import { useRouter } from "next/router";
import * as R from "ramda";
import { MouseEventHandler } from "react";
import { getAsPath } from "../../../helper/openUrl";
import { getRelByHref, getTargetByHref } from "../../../helper/utils";

type NavigationDestination = {
    href: string;
    isLocalized?: boolean;
    target?: string;
} | {
    href?: undefined;
    onClick: MouseEventHandler<HTMLDivElement>;
}

type NavigationButtonProps = NavigationDestination & {
    isEnabled?: boolean;
}

const NavigationButton: React.FC<NavigationButtonProps> = (props) => {
    if (props.isEnabled === false) {
        return (
            <span>
                {props.children}
            </span>
        );
    }

    if (props.href === undefined) {
        return (
            <span onClick={props.onClick} style={{ cursor: "pointer" }}>
                {props.children}
            </span>
        );
    } else {
        const router = useRouter();

        const localizedRef = props.isLocalized ? getAsPath(props.href, router) : props.href;
        const newTarget = R.isNil(props.target) ? getTargetByHref(props.href) : props.target;

        return (
            <a href={localizedRef}
               style={{ textDecoration: "none", cursor: "pointer" }}
               target={newTarget}
               rel={getRelByHref(props.href)}>
               {props.children}
            </a>
        );
    }
}

export default NavigationButton;